export default {
  statsTitle: "统计数据",
  statsSub: "统计数据",
  riderRankTitle: "骑手排行榜",
  riderRankSub: "骑手排行",
  storeDispatchTitle: "商家派单",
  storeDispatchSub: "商家派单",
  incomeShareTitle: "营业额占比",
  incomeShareSub: "营业额占比",
  chartOrderCount: "订单数",
  chartIncome: "营业额",
};
